import { or } from 'ember-truth-helpers';

import { Codemirror } from 'umg-ember-backend/components/ui/codemirror';

<template>
  <Codemirror
    @value={{or @value ''}}
    @readOnly={{@isDisabled}}
    @mode={{@mode}}
    @onUpdate={{@onUpdate}}
  />
</template>
